import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

const Breadcrumbs = (props) => {
  const { data, floatRight = false } = props;

  const liStyle = {};

  if (floatRight) {
    liStyle.marginLeft = 'auto';
  }

  const Wrapper = styled(`ol`)`
    flex-wrap: nowrap;

    li {
      white-space: nowrap;
    }
  `;

  return (
    <Wrapper className="breadcrumb m-0">
      {data.map((item, i) => (
        <li
          key={`breadcrumb-${i}`}
          className={`breadcrumb-item ${i === data.length - 1 ? 'active' : ''}`}
          style={i === 0 ? liStyle : {}}
        >
          {i !== data.length - 1 ? <Link to={item.route}>{item.title}</Link> : item.title}
        </li>
      ))}
    </Wrapper>
  );
};

export default Breadcrumbs;
